import React, { useState } from 'react';
import { Plus, X } from 'lucide-react';
import { INDUSTRIES } from './setupConstants';

export const StepNotifications = ({ form, setForm }) => {
  const [newEmail, setNewEmail] = useState('');

  const addEmail = () => {
    const e = newEmail.trim();
    if (!e) return;
    if (!form.notification_emails.includes(e)) {
      setForm(f => ({ ...f, notification_emails: [...f.notification_emails, e] }));
    }
    setNewEmail('');
  };

  const removeEmail = (email) => {
    setForm(f => ({ ...f, notification_emails: f.notification_emails.filter(x => x !== email) }));
  };

  const industryLabel = INDUSTRIES.find(i => i.value === form.industry)?.label || form.industry;

  return (
    <div className="space-y-6">
      <div>
        <label className="block text-xs text-white/50 mb-2">Notification Emails</label>
        <div className="flex gap-2 mb-2">
          <input
            type="email"
            value={newEmail}
            onChange={e => setNewEmail(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && addEmail()}
            placeholder="alerts@company.com"
            className="flex-1 bg-white/5 border border-white/10 rounded-lg px-3 py-2.5 text-white text-sm placeholder-white/20 focus:outline-none focus:border-teal-500/50"
            data-testid="notification-email-input"
          />
          <button onClick={addEmail} className="px-3 py-2 bg-teal-500 text-white rounded-lg hover:bg-teal-400" data-testid="add-email-btn">
            <Plus className="w-4 h-4" />
          </button>
        </div>
        {form.notification_emails.map(email => (
          <div key={email} className="flex items-center justify-between px-3 py-2 bg-white/5 rounded-lg mb-1">
            <span className="text-sm text-white/60">{email}</span>
            <button onClick={() => removeEmail(email)}><X className="w-4 h-4 text-white/30 hover:text-white" /></button>
          </div>
        ))}
        {form.notification_emails.length === 0 && (
          <p className="text-white/20 text-xs">No notification emails added</p>
        )}
      </div>

      <div className="bg-white/5 border border-white/10 rounded-xl p-5 space-y-3">
        <h3 className="text-white font-semibold text-sm">Setup Summary</h3>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between"><span className="text-white/40">Company</span><span className="text-white">{form.company.name || '—'}</span></div>
          <div className="flex justify-between"><span className="text-white/40">Domain</span><span className="text-teal-400">{form.yabbit_domain}</span></div>
          <div className="flex justify-between"><span className="text-white/40">Industry</span><span className="text-white">{industryLabel}</span></div>
          <div className="flex justify-between"><span className="text-white/40">Extensions</span><span className="text-white">{form.extensions_monitored.length} selected</span></div>
          <div className="flex justify-between"><span className="text-white/40">Coaching Types</span><span className="text-white">{Object.keys(form.extension_classifications).length} assigned</span></div>
          <div className="flex justify-between"><span className="text-white/40">Notifications</span><span className="text-white">{form.notification_emails.length} email(s)</span></div>
        </div>
      </div>
    </div>
  );
};
